<template>
    <component :is="tileComponent" class="layout-tile" :class="tileClasses" :href="url" :to="route">
        <div class="flex min-w-0 gap-x-4">
            <ImageTile
                v-if="image"
                :image="image"
                :imageLoading="imageLoading"
                :fetchPriority="fetchPriority"
            ></ImageTile>
            <div class="flex flex-col" :class="heading && excerpt ? 'space-y-1' : ''">
                <ContentTileHeading
                    v-if="heading"
                    :heading="heading"
                    :headingComponent="headingComponent"
                    :headingColor="headingColor"
                ></ContentTileHeading>
                <ContentTileExcerpt
                    v-if="excerpt"
                    :html="excerpt"
                ></ContentTileExcerpt>
            </div>
        </div>
        <!-- Actions Go Here -->
    </component>
</template>

<script>
export default {
    name: 'LayoutTile',
    props: {
        route: {
            required: false,
            type: [String, Object],
            default: null,
        },
        url: {
            required: false,
            type: String,
        },
        color: {
            required: false,
            type: String,
            default: 'bg-white hover:bg-zinc-50',
        },
        heading: {
            required: false,
            type: String,
            default: null,
        },
        headingComponent: {
            required: false,
            type: String,
            default: undefined,
        },
        headingColor: {
            required: false,
            type: String,
            default: undefined,
        },
        excerpt: {
            required: false,
            type: String,
            default: null,
        },
        image: {
            required: false,
            type: String,
            default: null,
        },
        imageAlt: {
            required: false,
            type: String,
            default: '',
        },
        imageLoading: {
            required: false,
            type: String,
            default: undefined,
        },
        fetchPriority: {
            required: false,
            type: [String, undefined],
            default: undefined,
        },
        rounding: {
            required: false,
            type: String,
            default: 'rounded-md',
        },
    },
    computed: {
        tileComponent () {
            if (this.route) return 'router-link';
            if (this.url) return 'a';
            return 'div';
        },
        tileClasses () {
            const cls = {};
            cls['flex justify-between gap-x-6 p-4'] = true;
            cls['cursor-pointer'] = !!this.route || !!this.url;
            cls[this.color] = true;
            cls[this.rounding] = true;
            return cls;
        },
    },
};
</script>
